var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLayer0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.95 9.00377L19.8 10.9772L11 15.4879L2.2 10.9772L6.12036 8.9677M15.95 13.3159L19.8 15.2893L11 19.8L2.2 15.2893L6.12036 13.2798M11 2.2L19.8 6.71068L11 11.2214L2.2 6.71068L11 2.2Z",
    stroke: "#383F43",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLayer0);
export default __webpack_public_path__ + "static/media/icon-layer-0.511fce39d676bb013463f092e48bf4d7.svg";
export { ForwardRef as ReactComponent };